import { DataBean } from "../DataBean";

export class RegisterPhysical extends DataBean {


    public async registerPhysicalTakingProduct(idPhysicalTaking:any,idProduct:any,productCode:any,quantity:any,observations:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.fixedassets.PhysicalTakingItem_registerPhysicalTakingProduct_Number_Number_Number_Number_String", [idPhysicalTaking,idProduct,productCode,quantity,observations]);
    }
public async registerPhysicalTakingFixedAssetItem(idPhysicalTaking:any,idItem:any,ticketCode:any,observations:any,state:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.fixedassets.PhysicalTakingItem_registerPhysicalTakingFixedAssetItem_Number_Number_Number_String_Number", [idPhysicalTaking,idItem,ticketCode,observations,state]);
    }
    
//aqui
 
}